import {
  detectFillers,
  suggestEmphasis,
  applyEmphasisSuggestions,
  type TranscriptWord,
} from '@captionflow/caption-engine';
import { demoTranscriptWords, DEMO_DURATION_MS } from '@captionflow/fixtures';
import { useEditor } from '../state/editorStore';

/**
 * Load the deterministic demo transcript into the editor so the whole editing
 * experience works with no backend / credentials. Filler ("um") is detected and
 * emphasis is suggested (numbers, currency, strong words) but nothing is hidden
 * until the user chooses to.
 */
export function loadDemo(videoUrl: string | null = null): void {
  let words: TranscriptWord[] = demoTranscriptWords();
  words = detectFillers(words);
  words = applyEmphasisSuggestions(words, suggestEmphasis(words));
  useEditor.getState().load({
    words,
    templateId: 'active-word',
    durationMs: DEMO_DURATION_MS,
    videoUrl,
  });
}
